import { Injector, Type } from '@angular/core';
import { AbstractGitService, GitParentFolders, GIT_PARENT_FOLDERS } from './abstract-git.service';

export interface AbstractGitFactoryServiceConfig<T extends AbstractGitService = AbstractGitService> {
  gitService: Type<T>;
  injector: Injector;
}

export abstract class AbstractGitFactoryService<GitService extends AbstractGitService = AbstractGitService> {
  constructor(protected readonly cfg: AbstractGitFactoryServiceConfig<GitService>) {}

  build(parentFolders?: GitParentFolders): GitService {
    const { gitService, injector } = this.cfg;
    const childInjector = Injector.create({
      name: `${gitService.name}-Injector`,
      parent: injector,
      providers: [
        {
          provide: GIT_PARENT_FOLDERS,
          useValue: parentFolders,
        },
        {
          provide: gitService,
          useClass: gitService,
        },
      ],
    });

    return childInjector.get(gitService);
  }
}
